module.exports = __webpack_public_path__ + "static/media/footer5.87ec9191.png";